var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "#E0E0E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8226 27H8.42261C8.22261 27 8.12261 26.9 8.02261 26.8C7.92261 26.7 7.82261 26.5 7.82261 26.4V20.1H2.22261C2.02261 20.1 1.92261 20 1.82261 19.9C1.72261 19.8 1.62261 19.6 1.62261 19.5V17.5C1.62261 17.3 1.72261 17.2 1.82261 17.1C1.92261 17 2.12261 16.9 2.22261 16.9H7.82261V15.3L6.32261 12L0.122607 0.9C0.0226074 0.7 0.0226074 0.5 0.122607 0.3C0.222607 0.1 0.422607 0 0.622607 0H4.42261C4.72261 0 4.92261 0.1 5.02261 0.3L9.22261 8.4C9.42261 8.9 9.82261 9.7 10.3226 10.8C10.4226 10.5 10.6226 10.1 10.9226 9.5C11.2226 8.9 11.3226 8.5 11.4226 8.3L15.1226 0.2C15.2226 0.0999998 15.4226 0 15.7226 0H19.4226C19.6226 0 19.8226 0.1 19.9226 0.3C20.0226 0.5 20.0226 0.7 19.9226 0.9L13.9226 12L12.4226 15.2V16.8H18.1226C18.3226 16.8 18.4226 16.9 18.5226 17C18.6226 17.1 18.7226 17.3 18.7226 17.4V19.4C18.7226 19.6 18.6226 19.7 18.5226 19.8C18.4226 19.9 18.2226 20 18.1226 20H12.4226V26.3C12.4226 26.5 12.3226 26.6 12.2226 26.7C12.1226 26.9 11.9226 27 11.8226 27Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpy);
export default __webpack_public_path__ + "static/media/Cpy.c5cf173c1e24a3c110a00d6ff98d40c6.svg";
export { ForwardRef as ReactComponent };